import React, { useState, useEffect, useContext } from "react";
import "./index.scss";
import FormGenerator from "../../../core/form-generator";
import { getClaimFormConfig } from "./config";
import { Box, IconButton } from "@mui/material";
import { handleFormValidation, PAGE_LIMIT } from "../../../utils";
import SiFileUpload from "../../../core/file-uploader";
import CustomButtonComponent from "../../../core/custom-button";
import { HTTP_METHODS, invokeApi, plainApi } from "../../../utils/http-service";
import { toast } from "react-toastify";
import { HOSTNAME, REST_URLS } from "../../../utils/endpoints";
import { Icon } from "@iconify/react";
import AppContext from "../../../utils/context";
import { STATES } from "../../../components/oems/helper";
import { getOfflineData } from "../../../utils/offline-services";

const CreateExportEngine = ({
  setIsCreate,
  loadData,
  editData,
  downloadReports,
}) => {
  const [formData, setFormData] = useState({});
  const [errors, setErrors] = useState({});
  const [files, setFiles] = useState([]);
  const [complaintCodes, setComplaintCodes] = useState([]);
  const [defectCodeList, setDefectCodeList] = useState([]);
  const [actionCodeList, setActionCodeList] = useState([]);
  const [oemList, setOemList] = useState([]);
  const { userDetails = {} } = useContext(AppContext);
  const loadOemOrg = () => {
    plainApi(HTTP_METHODS.GET, `${HOSTNAME}${REST_URLS.OEM_NAMES}`, null)
      .then((response) => {
        if (Array.isArray(response) && response) {
          const res = response.map((r) => ({
            label: r.name,
            value: r.id,
          }));
          setOemList(res);
        }
      })
      .catch((err) => console.error(err));
    plainApi(
      HTTP_METHODS.GET,
      `${HOSTNAME}${REST_URLS.LIST_COMPLAINT_CODES}`,
      null
    )
      .then((response) => {
        if (Array.isArray(response.results) && response.results) {
          let codes = response.results.map((r) => {
            return {
              ...r,
              label: `${r.code} - ${r.description || ""}`,
              value: r.id,
            };
          });
          setComplaintCodes(codes);
        }
      })
      .catch((err) => console.error(err));
  };

  const submitHandler = () => {
    const isValid = handleFormValidation(
      getClaimFormConfig(),
      setErrors,
      formData
    );

    if (isValid) {
      const payload = {
        ...formData,
        complaintCode: formData?.complaintCode?.value,
        complaintDescription: formData?.complaintCode?.label
          ?.split("-")[1]
          ?.trim(),
        defectCode: formData?.defectCode?.value,
        defectDescription: formData?.defectCode?.label?.split("-")[1]?.trim(),
        actionCode: formData?.actionCode?.value,
        actionTaken: formData?.actionCode?.label?.split("-")[1]?.trim(),
        oemOrg: formData?.oemOrg?.value,
      };
      if (editData?.id) {
        invokeApi(
          HTTP_METHODS.PUT,
          `${HOSTNAME}${REST_URLS.EXPORT_ENGINE_TRACKING}/${editData.id}`,
          payload
        )
          .then((res) => {
            if (res.message) {
              toast.error(res.message);
            } else {
              toast.success("Claims Updated Successfully");
              setIsCreate(false);
              loadData({ page: 1, sortBy: "-createdAt", limit: PAGE_LIMIT });
            }
          })
          .catch((err) => console.error(err));
      } else {
        invokeApi(
          HTTP_METHODS.POST,
          `${HOSTNAME}${REST_URLS.EXPORT_ENGINE_TRACKING}`,
          payload
        )
          .then((res) => {
            if (res.message) {
              toast.error(res.message);
            } else {
              toast.success("Claims Created Successfully");
              setIsCreate(false);
              loadData({ page: 1, sortBy: "-createdAt", limit: PAGE_LIMIT });
            }
          })
          .catch((err) => console.error(err));
      }
    }
  };
  const loadDefectCodes = () => {
    plainApi(HTTP_METHODS.GET, `${HOSTNAME}${REST_URLS.GET_CODES}`, null, {
      type: "defect",
      page: 1,
      limit: 1000,
    })
      .then((response) => {
        if (response.results) {
          const codeList = response.results.map((ele) => ({
            label: `${ele.code}-${ele.description}`,
            value: `${ele.id}`,
          }));
          setDefectCodeList(codeList);
        }
      })
      .catch((err) => console.error(err));
    plainApi(HTTP_METHODS.GET, `${HOSTNAME}${REST_URLS.GET_CODES}`, null, {
      type: "action",
      page: 1,
      limit: 1000,
    })
      .then((response) => {
        if (response.results) {
          const codeList = response.results.map((ele) => ({
            label: `${ele.code}-${ele.description}`,
            value: `${ele.id}`,
          }));
          setActionCodeList(codeList);
        }
      })
      .catch((err) => console.error(err));
  };
  const callBack = (newFile) => {
    setFiles([...files, newFile]);
  };

  const onDelete = (index) => {
    files.splice(index, 1);
    setFiles([...files]);
  };

  useEffect(() => {
    loadDefectCodes();
    loadOemOrg();
  }, []);
  useEffect(() => {
    if (editData?.id) {
      const {
        oemOrg,
        actionCode,
        actionTaken,
        application,
        complaintCode,
        complaintDescription,
        complaintReportedDate,
        complaintStatus,
        country,
        defectCode,
        defectDescription,
        ecnDetails,
        engineModel,
        engineNo,
        hmr,
        invoiceDate,
        listNumber,
        machineModel,
        oemSe,
        plant,
        remarks,
        saleDate,
        location,
      } = editData;
      setFormData((prevVal) => ({
        ...prevVal,
        location,
        complaintDescription,
        complaintReportedDate,
        complaintStatus,
        country,
        actionCode,
        actionTaken,
        defectDescription,
        application,
        defectCode,
        ecnDetails,
        engineModel,
        engineNo,
        hmr,
        invoiceDate,
        listNumber,
        machineModel,
        oemSe,
        plant,
        remarks,
        saleDate,
        complaintCode: complaintCodes?.find(
          (ele) => ele?.value === complaintCode?.id
        ),
        oemOrg: oemList?.find((ele) => ele?.value === oemOrg?.id),
        defectCode: defectCodeList?.find(
          (ele) => ele?.value === defectCode?.id
        ),
        actionCode: actionCodeList?.find(
          (ele) => ele?.value === actionCode?.id
        ),
      }));
    }
  }, [complaintCodes, defectCodeList, actionCodeList, oemList]);

  return (
    <div>
      <div className="form-con" style={{ width: "100%" }}>
        <FormGenerator
          config={getClaimFormConfig(
            complaintCodes,
            defectCodeList,
            actionCodeList,
            oemList
          )}
          formData={formData}
          setFormData={setFormData}
          errors={errors}
          setErrors={setErrors}
        />

        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            mt: 2,
            mb: 2,
            alignItems: "center",
          }}
        >
          <CustomButtonComponent
            variant="contained"
            color="primary"
            sx={{ width: "200px", ml: 3 }}
            onClick={submitHandler}
          >
            Submit
          </CustomButtonComponent>
        </Box>
      </div>
    </div>
  );
};

export default CreateExportEngine;
